export function debounce(callback, timeout = 250) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            callback.apply(null, args);
        }, timeout);
    };
}
